import { useRef, useCallback } from "react";

export default function useGlobalDebounceClick(callback, delay = 2000) {
  const lastClick = useRef(0);

  return useCallback(
    (...args) => {
      const now = Date.now();
      if (now - lastClick.current >= delay) {
        lastClick.current = now;
        callback(...args);
      } else {
        console.log("Blokováno: Globální cooldown je aktivní.");
      }
    },
    [callback, delay],
  );
}
